export default "dist/images/block-feature-overlap-shape5.34be3b7.png";